// Type-aware "is this field filled" check, shared by the rendered onboarding
// forms (Form Master + Onboarding Initiation) for the section-level
// "minimum N of M fields" validation rule.
export const isFieldFilled = (value, fieldType) => {
  if (fieldType === "file") {
    return Boolean(value);
  }

  if (fieldType === "multiselect" || fieldType === "checkbox") {
    if (Array.isArray(value)) return value.length > 0;
    return Boolean(value);
  }

  if (fieldType === "date" || fieldType === "datetime") {
    return value !== null && value !== undefined;
  }

  if (fieldType === "number") {
    return value !== "" && value !== null && value !== undefined;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return String(value ?? "").trim().length > 0;
};
